import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

const initialState = {
  startDate: null,
  endDate: null,
};

export default handleActions(
  {
    [Actions.UPDATE_SEARCH_PARAMS]: (
      state,
      { payload: { startDate, endDate } },
    ) => ({
      ...state,
      startDate,
      endDate,
    }),
  },
  initialState,
);
